import React, { useContext } from 'react';
import { ContainerQueryContext } from '../../../../util/ContainerQuery.context';
import * as Styled from './ResponsiveImageGallery.styled';
import ImageCarouselLarge from './components/ImageCarouselLarge/ImageCarouselLarge';
import ImageCarouselMedium from './components/ImageCarouselMedium/ImageCarouselMedium';
/**
 * Displays product images in different formats based on breakpoint
 */
var ResponsiveImageGallery = function (_a) {
    var className = _a.className, images = _a.images;
    var styleQueryMode = useContext(ContainerQueryContext).styleQueryMode;
    if (!(images === null || images === void 0 ? void 0 : images.length))
        return null;
    return (React.createElement(Styled.ResponsiveImageGallery, { className: className, "$styleQueryMode": styleQueryMode, "data-label": "imageGallery" },
        React.createElement(ImageCarouselMedium, { images: images }),
        React.createElement(ImageCarouselLarge, { images: images })));
};
export default ResponsiveImageGallery;
